import { render, staticRenderFns } from "./AccountPasswordReminderPopup.vue?vue&type=template&id=72fb1ac5&scoped=true&"
import script from "./AccountPasswordReminderPopup.vue?vue&type=script&lang=js&"
export * from "./AccountPasswordReminderPopup.vue?vue&type=script&lang=js&"
import style0 from "./AccountPasswordReminderPopup.vue?vue&type=style&index=0&id=72fb1ac5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72fb1ac5",
  null
  
)

export default component.exports